// @ts-nocheck
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import MobiusSelect, { SelectProps } from "@insite/mobius/Select";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC, useState } from "react";
import { useTheme } from "styled-components";

const errorText = "This field is invalid.";

const Select: FC<SelectProps> = props => (
    <MobiusSelect {...props}>
        <option value="">{props.placeholder}</option>
        <option value="1">Option #1</option>
        <option value="2">Option #2</option>
        <option value="3">Option #3</option>
        <option value="4">Option #4</option>
        <option value="5">Option #5</option>
    </MobiusSelect>
);

const Row: FC<SelectProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <Select label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <Select label={`${label} (Disabled)`} disabled {...props} />
        </GridItem>
        <GridItem width={4}>
            <Select label={`${label} (Error)`} required error={errorText} {...props} />
        </GridItem>
    </>
);

const Variant: FC<SelectProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);
    const [sectionId] = useState(`subsection-${uniqueId()}`);

    return (
        <StyleguideSection variant="h3" title={upperFirst(sizeVariant)} sectionId={sectionId} isSubSection>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" sizeVariant={sizeVariant} />
                <Row label="Placeholder" sizeVariant={sizeVariant} placeholder="Select an option" />
                <Row label="Inline" sizeVariant={sizeVariant} labelPosition="left" placeholder="Select an option" />
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideDropdowns: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Dropdowns" sectionId={sectionId}>
            <Variant sizeVariant="default" />
            <Variant sizeVariant="small" />
            <Variant sizeVariant={"xsmall" as any} />
        </StyleguideSection>
    );
};

export default StyleguideDropdowns;
